import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loadUserProfile } from "../../redux/actions/authActions";

const FormModalUpdateProfilClient = ({ onClose }) => {

    const { user, token } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    const photoInputRef = useRef(null);
    const logoInputRef = useRef(null);

    const [updateSuccess, setUpdateSuccess] = useState(false);

    const [photoPreview, setPhotoPreview] = useState(
        user?.profilClient?.photoProfilUrl || ""
    );

    const [logoPreview, setLogoPreview] = useState(
        user?.profilClient?.logoEntrepriseUrl || ""
    );

    const [formData, setFormData] = useState({
        nom: user.profilClient.lastNameClient,
        prenom: user.profilClient.firstNameClient,
        type: user.profilClient.typeClient,
        billingAddress: user.profilClient.addressClient,
        billingPostalCode: user.profilClient.postalCodeClient,
        billingCity: user.profilClient.cityClient,
        billingCountry: user.profilClient.countryCodeClient,
        phoneNumber: user.profilClient.phoneClient,
        raisonSociale: user.profilClient.raisonSocialeClient,
        siret: user.profilClient.numSiretClient,
        numTva: user.profilClient.numTvaClient,
        nomAssociation: user.profilClient.nameAssociationClient,
        rna: user.profilClient.numRnaClient,
        nomOrganisation: user.profilClient.nameOrganisationClient,
        typeOrganisation: user.profilClient.typeOrganisationClient,
        numEnregistrement: user.profilClient.numEnregistrementOrganisationClient,
    });

    const [step, setStep] = useState(1);
    const [errors, setErrors] = useState({});
    const apiUrl = process.env.REACT_APP_API_URL;
    const dispatch = useDispatch();
    useEffect(() => {
        if (!user || !user.profilClient) navigate("/");
    }, [user, navigate]);

    if (!user || !user.profilClient) return null;
    const validateField = (name, value) => {
        let fieldErrors = { ...errors };

        switch (name) {
            case "nom":
                value.length < 2 ? fieldErrors.nom = "Le nom doit contenir au moins 2 caractères" : delete fieldErrors.nom;
                break;

            case "prenom":
                value.length < 2 ? fieldErrors.prenom = "Le prénom doit contenir au moins 2 caractères" : delete fieldErrors.prenom;
                break;

            case "billingAddress":
                value.length < 5 ? fieldErrors.billingAddress = "Adresse trop courte" : delete fieldErrors.billingAddress;
                break;

            case "billingPostalCode":
                !/^\d{5}$/.test(value) ? fieldErrors.billingPostalCode = "Code postal invalide" : delete fieldErrors.billingPostalCode;
                break;

            case "billingCity":
                value.length < 2 ? fieldErrors.billingCity = "Ville trop courte" : delete fieldErrors.billingCity;
                break;

            case "phoneNumber":
                !/^\d{10}$/.test(value) ? fieldErrors.phoneNumber = "Numéro invalide" : delete fieldErrors.phoneNumber;
                break;

            default:
                break;
        }

        setErrors(fieldErrors);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        validateField(name, value);
    };

    // Gestion fichiers
    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        if (type === "photoProfil") {
            setFormData((prev) => ({ ...prev, photoProfil: file }));
            setPhotoPreview(URL.createObjectURL(file));
        }

        if (type === "logoEntreprise") {
            setFormData((prev) => ({ ...prev, logoEntreprise: file }));
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const handleRemoveFile = (type) => {
        if (type === "photoProfil") {
            if (photoPreview.startsWith("blob:")) URL.revokeObjectURL(photoPreview);
            setFormData((p) => ({ ...p, photoProfil: null }));
            setPhotoPreview(user.profilClient.photoProfilUrl || "");
            if (photoInputRef.current) photoInputRef.current.value = "";
        }

        if (type === "logoEntreprise") {
            if (logoPreview.startsWith("blob:")) URL.revokeObjectURL(logoPreview);
            setFormData((p) => ({ ...p, logoEntreprise: null }));
            setLogoPreview(user.profilClient.logoEntrepriseUrl || "");
            if (logoInputRef.current) logoInputRef.current.value = "";
        }
    };

    const isStep1Valid =
        !errors.nom &&
        !errors.prenom &&
        !errors.billingAddress &&
        !errors.billingPostalCode &&
        !errors.billingCity &&
        !errors.phoneNumber &&
        formData.nom &&
        formData.prenom &&
        formData.billingAddress &&
        formData.billingPostalCode &&
        formData.billingCity &&
        formData.phoneNumber;

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const submitData = new FormData();

            // Champs basiques
            Object.keys(formData).forEach((key) => {
                if (
                    formData[key] !== null &&
                    formData[key] !== undefined &&
                    formData[key] !== ""
                ) {
                    submitData.append(key, formData[key]);
                }
            });

            // Fichiers
            if (formData.photoProfil instanceof File) {
                submitData.append("photoProfil", formData.photoProfil);
            }
            if (formData.logoEntreprise instanceof File) {
                submitData.append("logoEntreprise", formData.logoEntreprise);
            }

            const response = await fetch(`${apiUrl}/api/updateProfil/client`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: submitData,
            });

            const result = await response.json();

            if (!response.ok) {
                console.error(result);
                alert(result.error || "Erreur lors de la mise à jour");
                return;
            }

            setUpdateSuccess(true);

            // mise à jour Redux auth
            dispatch(loadUserProfile(token));


            // fermer la modal après succès
            setTimeout(() => {
                onClose();
            }, 800);

        } catch (error) {
            console.error("Erreur fetch:", error);
            alert("Impossible d’enregistrer les modifications.");
        }
    };

    return (
        <div className="inscriptionModalOverlay">
            <div className="inscriptionModal">
                <button className="inscriptionModalClose" onClick={onClose}>×</button>

                <h2>Mise à jour du Profil</h2>

                <form onSubmit={handleSubmit}>
                    {step === 1 && (
                        <>
                            <h3>Vos informations personnelles</h3>

                            {/* type */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Type de client</label>
                                <div className="radio-group">
                                    {["particulier", "entreprise", "association", "autre"].map(t => (
                                        <label key={t}>
                                            <input
                                                type="radio"
                                                name="type"
                                                value={t}
                                                checked={formData.type === t}
                                                onChange={handleChange}
                                            />
                                            {t.charAt(0).toUpperCase() + t.slice(1)}
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* Nom */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Nom</label>
                                <input name="nom" value={formData.nom} onChange={handleChange} />
                                {errors.nom && <p className="error-text">{errors.nom}</p>}
                            </div>

                            {/* Prénom */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Prénom</label>
                                <input name="prenom" value={formData.prenom} onChange={handleChange} />
                                {errors.prenom && <p className="error-text">{errors.prenom}</p>}
                            </div>

                            {/* Adresse */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Adresse de facturation</label>
                                <input name="billingAddress" value={formData.billingAddress} onChange={handleChange} />
                                {errors.billingAddress && <p className="error-text">{errors.billingAddress}</p>}
                            </div>

                            {/* CP */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Code postal</label>
                                <input name="billingPostalCode" value={formData.billingPostalCode} onChange={handleChange} />
                                {errors.billingPostalCode && <p className="error-text">{errors.billingPostalCode}</p>}
                            </div>

                            {/* Ville */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Ville</label>
                                <input name="billingCity" value={formData.billingCity} onChange={handleChange} />
                                {errors.billingCity && <p className="error-text">{errors.billingCity}</p>}
                            </div>

                            {/* Téléphone */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Téléphone</label>
                                <input name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} />
                                {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}
                            </div>

                            {/* Photo */}
                            <div className="inscriptionClientModal-input-form">
                                <label>Photo de profil</label>

                                <input
                                    ref={photoInputRef}
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleFileChange(e, "photoProfil")}
                                />

                                {photoPreview && (
                                    <div style={{ textAlign: "center" }}>
                                        <img
                                            src={photoPreview}
                                            alt="Preview"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                borderRadius: "50%",
                                                objectFit: "cover"
                                            }}
                                        />
                                        <button type="button" onClick={() => handleRemoveFile("photoProfil")}>
                                            Supprimer
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="inscriptionClientModal-actions">
                                {formData.type === "particulier" ? (
                                    <button disabled={!isStep1Valid}>
                                        ENREGISTRER
                                    </button>
                                ) : (
                                    <button disabled={!isStep1Valid} onClick={() => setStep(2)}>
                                        SUIVANT
                                    </button>
                                )}
                            </div>
                        </>
                    )}

                    {/* --- STEP 2 --- */}
                    {step === 2 && (
                        <>
                            {formData.type === "entreprise" && (
                                <>
                                    <h3>Informations entreprise</h3>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>Raison sociale</label>
                                        <input name="raisonSociale" value={formData.raisonSociale || ""} onChange={handleChange} />
                                    </div>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>N° SIRET</label>
                                        <input name="siret" value={formData.siret || ""} onChange={handleChange} />
                                    </div>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>N° TVA</label>
                                        <input name="numTva" value={formData.numTva || ""} onChange={handleChange} />
                                    </div>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>Logo entreprise</label>
                                        <input ref={logoInputRef} type="file" accept="image/*" onChange={(e) => handleFileChange(e, "logoEntreprise")} />

                                        {logoPreview && (
                                            <div style={{ textAlign: "center" }}>
                                                <img src={logoPreview} alt="Logo" style={{ width: "150px" }} />
                                                <button type="button" onClick={() => handleRemoveFile("logoEntreprise")}>
                                                    Supprimer
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}

                            {formData.type === "association" && (
                                <>
                                    <h3>Informations association</h3>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>Nom</label>
                                        <input name="nomAssociation" value={formData.nomAssociation || ""} onChange={handleChange} />
                                    </div>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>N° RNA</label>
                                        <input name="rna" value={formData.rna || ""} onChange={handleChange} />
                                    </div>
                                </>
                            )}

                            {formData.type === "autre" && (
                                <>
                                    <h3>Informations supplémentaires</h3>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>Organisation</label>
                                        <input name="nomOrganisation" value={formData.nomOrganisation || ""} onChange={handleChange} />
                                    </div>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>Type</label>
                                        <input name="typeOrganisation" value={formData.typeOrganisation || ""} onChange={handleChange} />
                                    </div>

                                    <div className="inscriptionClientModal-input-form">
                                        <label>N° d’enregistrement</label>
                                        <input name="numEnregistrement" value={formData.numEnregistrement || ""} onChange={handleChange} />
                                    </div>
                                </>
                            )}

                            <div className="inscriptionClientModal-actions">
                                <button onClick={() => setStep(1)}>PRÉCÉDENT</button>
                                <button type="submit">ENREGISTRER</button>
                            </div>
                        </>
                    )}
                </form>
            </div>
        </div>
    );
};

export default FormModalUpdateProfilClient;
